import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormLayoutTitle, FormWidgetsTitle } from "../../../../../Constants/Constants";
import NumberingWizard from "./NumberingWizard/NumberingWizard";
import ShippingForm from "./ShippingForm/ShippingForm";
import StudentValidationForm from "./StudentValidationForm/StudentValidationForm";
import VerticalValidationWizard from "./VerticalValidationWizard/VerticalValidationWizard";
import { Fragment } from "react/jsx-runtime";

const FormWizard1Container = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={FormWidgetsTitle} parent={FormLayoutTitle} />
      <Container fluid>
        <Row>
          <NumberingWizard />
          <StudentValidationForm />
          <VerticalValidationWizard />
          <ShippingForm />
        </Row>
      </Container>
    </Fragment>
  );
};
export default FormWizard1Container;
